<template>
  <Heading 
    :level="4"
    color="text-ash-200 mb-[1.5rem] !text-[1.142857rem] leading-6"
  >
    {{ title }}
  </Heading>
  <p :class=[descriptionColor]>{{ decodedDescription }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Heading from '../../../atom/heading.vue'
import { decodeHtml } from '~/components/utils/decodeHtml'
import type {HeadingProps} from "#shared/types/common";
interface DescriptionProps {
  title?: string
  description?: string
  descriptionColor?: string
}
const props = withDefaults(defineProps<DescriptionProps >(), {
  title: '',
  description: '',
  descriptionColor: 'text-ash-100',
})

const decodedDescription = computed(() => decodeHtml(props.description))
</script>
